import { AppData } from '../../services';
import React from 'react';
import { useState } from 'react';

const PinPopup = () => {
	const [pin, setPin] = useState('');
	if (!AppData.IS_STAGE || pin === '7600') {
		return null;
	}
	//popup
	return (

		<div className={'pip_popup_main_container'}>
			<div className={'pip_popup_content'}>
				<div>
					<div className={'pip_popup_text'}>
						<h4>Please enter Pin To continue</h4>
					</div>
					<div className={'pip_popup_input'}>
						<input type="text" placeholder="Enter Pin" onChange={e => setPin(e.target.value)} />
					</div>
				</div>
			</div>
		</div>

	);
};

export default PinPopup;



// WEBPACK FOOTER //
// ./src/features/pin-popup/index.js